import React, { useState } from "react";

import AntTextArea, {
  TextAreaProps as AntdTextAreaProps,
} from "antd/lib/input/TextArea";
import styled from "styled-components";
import { theme } from "../../../theme";

export interface TextAreaProps extends AntdTextAreaProps {
  maxWidth?: string;
}

const TextArea: React.FC<TextAreaProps> = (props) => {
  const {
    style,
    placeholder,
    maxLength,
    disabled,
    onChange,
    onBlur,
    maxWidth,
    ...rest
  } = props;
  const [isFocus, setFocus] = useState(false);
  return (
    <div
      style={{
        transition: "all 0.3s",
        boxShadow: isFocus
          ? "0 0 0 2px rgb(106 28 252 / 20%)"
          : `0 0 0 0px ${theme.colors.gray7}`,
        border: `1px solid ${
          isFocus ? theme.colors.mainPrimary3 : theme.colors.gray7
        }`,
        background: disabled ? theme.colors.gray9 : "#FFFFFF",
        borderRadius: "4px",
        paddingTop: "8px",
        width: "auto",
        paddingBottom: "32px",
        maxWidth: maxWidth || "480px",
      }}
      onBlur={() => {
        setFocus(false);
      }}
    >
      <StyledTextArea
        placeholder={placeholder || "검색어를 입력해주세요"}
        style={{
          ...style,
          width: "100%",
          minHeight: maxLength !== undefined ? "128px" : "160px",
        }}
        disabled={disabled}
        onFocus={() => {
          setFocus(true);
        }}
        onChange={(e) => {
          if (onChange) onChange(e);
        }}
        onBlur={(e) => {
          if (onBlur) onBlur(e);
          setFocus(false);
        }}
        maxLength={maxLength}
        showCount={maxLength !== undefined}
        bordered={false}
        {...rest}
      />
    </div>
  );
};

TextArea.defaultProps = {};
const StyledTextArea = styled(AntTextArea)`
  resize: none;
  min-height: 160px;
  .ant-input {
    width: 100%;
    min-height: inherit;
    resize: none;
    min-height: 160px;
  }
  ::after {
    line-height: 32px;
    margin-right: 12px;
  }
`;
export default TextArea;
